<script>
import { mapActions } from 'vuex';
import { result } from 'lodash';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'MeasureNoteDialog',
  mixins: [snackbarMixin],
  props: {
    measureItemId: {
      type: Number,
      required: true,
    },
    measureItemNote: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      baseFormData: {},
      formData: {},
    };
  },
  created() {
    this.formData = { id: this.measureItemId, note: this.measureItemNote };
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('privacyAuditDetails', ['saveMeasure']),
    submit() {
      this.isLoading = true;

      return this.saveMeasure(this.formData)
        .then(() => {
          this.showSuccessMessage('Die Notiz wurde gespeichert.');
          this.close();
          this.$emit('submit');
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.visible = false;
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Notiz der Maßnahme bearbeiten
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex md12>
              <v-textarea
                v-model="formData.note"
                label="Notizen"
                height="44"
                class="caption"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <div>
          <v-btn @click.native="submit"
                 color="blue"
                 :loading="isLoading"
                 flat>
            Speichern
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
